import { IconCondition } from '@components/icons/condition';
import { RelativeSpinner } from '@components/loading-spinner';
import { hideSidebar, Sidebar } from '@components/sidebar';
import { useScopedTranslate } from '@locale/translate';

import { useJourneyAction, useUpdateJourneyAction } from 'api/journey-actions/hooks';
import { ActionHeader, SidebarProps } from 'ui/journey-builder/node-types/common';

import { ConditionFormContent } from './helpers';

type ActionType = 'condition_v2';

export const SidebarContent = (props: SidebarProps) => {
  const { journeyActionId } = props;
  const { t } = useScopedTranslate(sidebarLocale);

  const editMutation = useUpdateJourneyAction(journeyActionId);

  const { data, isLoading } = useJourneyAction<ActionType>(journeyActionId);

  if (isLoading || !data) {
    return <RelativeSpinner />;
  }
  return (
    <Sidebar>
      <ActionHeader title={t('condition')} icon={IconCondition} iconColor="teal100" {...props} />
      <Sidebar.Content>
        <ConditionFormContent
          action={data}
          showDescriptionField
          conditionDescription={t('conditionDescription')}
          journeyId={data.journey}
          onCancel={hideSidebar}
          onSubmit={(data) =>
            editMutation.mutateAsync({
              isAutomatic: true,
              action: 'condition_v2',
              values: data,
              description: data.description,
            })
          }
        />
      </Sidebar.Content>
    </Sidebar>
  );
};

const sidebarLocale = {
  en: {
    conditionDescription: 'Continues',
    condition: 'Condition',
  },
};
